






































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import {
  ComBox,
  getCurrentFloorSensorData,
  getNumRunsInDryRun,
} from "@/data/models/ComBox";

import SensorStatusComponent from "@/components/combox/SensorStatus.vue";
import { formatDurationSince, formatFullJsDate } from "@/utils/DateFormatter";
import { formatKWh } from "@/utils/LocalisationHelper";
import {
  ComBoxSensorData,
  formatHumidity,
} from "@/data/models/ComBoxSensorData";
import { MinMaxKeyValueAggregator } from "@/utils/SensorData";
import {
  calculateAbsoluteHumidity,
  calculateComBoxHumidityPd,
  calculateMixingRatio,
  getComBoxHumidityUnitFormatRes,
  getHumidityValue,
} from "@/data/models/ComBoxHumidityUnit";
import { getComBoxHumidityUnit } from "@/data/repository/SettingsRepository";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "sensor-status": SensorStatusComponent,
  },
})
export default class TerminateDryRunComponent extends Vue {
  @Prop()
  comBox!: ComBox;

  sensorSelect = [true, true, true, true, true];

  startComBox = true;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  get comBoxStatus() {
    return this.comBox.comBoxStatus;
  }

  get dryRunStartDate() {
    return formatFullJsDate(this.comBoxStatus.dryRunStartDate.toDate());
  }

  get dryRunDuration() {
    return formatDurationSince(this, this.comBoxStatus.dryRunStartDate);
  }

  get dryRunNumRuns() {
    return this.$tc(
      "common.formatRuns",
      getNumRunsInDryRun(this.comBoxStatus)
    ).toString();
  }

  get meterReadingStart() {
    return formatKWh(this, this.comBoxStatus.dryRunInitialMeterReadingInKwh);
  }

  get meterReadingCurrent() {
    return formatKWh(this, this.comBoxStatus.currentMeterReadingInKwh);
  }

  get powerConsumption() {
    return formatKWh(
      this,
      Math.max(
        0,
        this.comBoxStatus.currentMeterReadingInKwh -
          this.comBoxStatus.dryRunInitialMeterReadingInKwh
      )
    );
  }

  get dryRunInitialHumidity() {
    const initialHumidity = this.comBoxStatus.dryRunInitialHumidity;
    const initialTemperature = this.comBoxStatus.dryRunInitialTemperature;

    if (initialHumidity == null || initialTemperature == null) {
      return "";
    }

    const pd = calculateComBoxHumidityPd(initialTemperature, initialHumidity);

    const sensorData: ComBoxSensorData = {
      sensorIndex: 0,
      temperature: initialTemperature,
      relativeHumidity: initialHumidity,
      absoluteHumidity: calculateAbsoluteHumidity(initialTemperature, pd),
      mixingRatio: calculateMixingRatio(pd),
    };

    return formatHumidity(this, sensorData);
  }

  get dryRunCurrentHumidity() {
    const humidityUnit = getComBoxHumidityUnit();
    
      const humidityCurrent = new MinMaxKeyValueAggregator(
      (value) => value !== undefined && value !== 255
    );

    getCurrentFloorSensorData(this.comBoxStatus).forEach((sensorData) => {
      humidityCurrent.addValue(getHumidityValue(humidityUnit, sensorData));
    });

    const currentHumidity = humidityCurrent.toMinMaxKeyValue().max;
    return currentHumidity === undefined
      ? null
      : this.$t(getComBoxHumidityUnitFormatRes(humidityUnit), [
          currentHumidity.toLocaleString(undefined, {
            maximumFractionDigits: 1,
          }),
        ]);
  }

  async show() {
    this.baseDialogComponent.show({
      styleAsAlertDialog: true,
      title: this.$t("comBoxDetail.terminateDryRun.terminateDryRun").toString(),
      negativeButtonText: this.$t("common.back").toString(),
      positiveButtonText: this.$t(
        "comBoxDetail.terminateDryRun.terminateDryRun"
      ).toString(),
      persistent: true,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    this.resolve && this.resolve(true);
  }
}
